var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"recordBox comStyBox"},[_c('yNavBar',{attrs:{"title":_vm.title}}),_c('div',{staticClass:"contentbox"},[_c('div',{staticClass:"content-wrapper",domProps:{"innerHTML":_vm._s(_vm.infocontent)}})])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }